import React from "react";
import {css, Theme} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";

import {IReelSize} from "../../../types/IReelSize";
import {ReelAuthorName} from "./ReelAuthorName";
import {ReelBox} from "./ReelBox";
import {ReelDescription} from "./ReelDescription";

interface IProps {
    size: IReelSize;
    className?: string;
}

export const ReelSkeletonLoader = (props: IProps) => {
    return (
        <ReelBox cover={<div css={reelCoverStyle} />} logo={<div />} size={props.size} className={props.className}>
            <ReelAuthorName size={props.size} css={reelAuthorNameStyle}>
                &nbsp;
            </ReelAuthorName>
            <ReelDescription size={props.size} css={reelTitleStyle}>
                &nbsp;
            </ReelDescription>
        </ReelBox>
    );
};

const reelCoverStyle = (theme: Theme) => css`
    background: linear-gradient(90deg, ${theme.colors.gray[400]}, ${theme.colors.gray[500]});
    width: 100%;
    height: 100%;
`;

const shineEffect = (theme: Theme) => css`
    background: linear-gradient(110deg, ${theme.colors.gray[600]} 8%, ${theme.colors.gray[300]} 18%, ${theme.colors.gray[600]} 33%);
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;

    @keyframes shine {
        to {
            background-position-x: -200%;
        }
    }
`;

const reelAuthorNameStyle = (theme: Theme) => css`
    ${mb(0.5)};
    width: 50%;
    background-color: ${theme.colors.gray[400]};
    ${shineEffect(theme)};
`;

const reelTitleStyle = (theme: Theme) => css`
    width: 90%;
    background-color: ${theme.colors.gray[400]};
    ${shineEffect(theme)};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";

import {IReelSize} from "../../../types/IReelSize";
import {ReelAuthorName} from "./ReelAuthorName";
import {ReelBox} from "./ReelBox";
import {ReelDescription} from "./ReelDescription";

interface IProps {
    size: IReelSize;
    className?: string;
}

export const ReelSkeletonLoader = (props: IProps) => {
    return (
        <ReelBox cover={<div css={reelCoverStyle} />} logo={<div />} size={props.size} className={props.className}>
            <ReelAuthorName size={props.size} css={reelAuthorNameStyle}>
                &nbsp;
            </ReelAuthorName>
            <ReelDescription size={props.size} css={reelTitleStyle}>
                &nbsp;
            </ReelDescription>
        </ReelBox>
    );
};

const reelCoverStyle = (theme: Theme) => css`
    background: linear-gradient(90deg, ${theme.colors.gray[400]}, ${theme.colors.gray[500]});
    width: 100%;
    height: 100%;
`;

const shineEffect = (theme: Theme) => css`
    background: linear-gradient(110deg, ${theme.colors.gray[600]} 8%, ${theme.colors.gray[300]} 18%, ${theme.colors.gray[600]} 33%);
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;

    @keyframes shine {
        to {
            background-position-x: -200%;
        }
    }
`;

const reelAuthorNameStyle = (theme: Theme) => css`
    ${mb(0.5)};
    width: 50%;
    background-color: ${theme.colors.gray[400]};
    ${shineEffect(theme)};
`;

const reelTitleStyle = (theme: Theme) => css`
    width: 90%;
    background-color: ${theme.colors.gray[400]};
    ${shineEffect(theme)};
`;
